export default __webpack_public_path__ + "static/media/e320ee1fbb7df4136b9c1e745dbc62aa.b82876dd.png";